import React, { useEffect, useRef, useState } from "react";
import * as R from "ramda";
import { fetchServiceDataForServiceType } from "../../../../actions/services-api";
import { useDispatch, useSelector } from "react-redux";
import { CheckboxCard } from "./checkboxCard";
import { ConnectionTypes, isSocialNetwork } from "../../../../constants/utils/connectionTypes";

export const ServiceNavbar = ({ selectedService, setSelectedService, personnalOptions, commonOptions, otherOption }) => {
	const dispatch = useDispatch();
	const services = useSelector((state) => state.services);
	const user = useSelector((state) => state.user);
	const bottomRef = useRef(null);
	const topRef = useRef(null);
	const selectedServiceRef = useRef(null);
	const [selectedServices, setSelectedServices] = useState([]);
	const isFirefox = typeof InstallTrigger !== "undefined";

	const isInsurance = (str) => [ConnectionTypes.scooter, ConnectionTypes.moto, ConnectionTypes.bateau, ConnectionTypes.voitureAssurance, ConnectionTypes.insurance].includes(str);

	// Update selectedServices when user.services changes
	useEffect(() => {
		if (user?.services?.length > 0) {
			setSelectedServices(user.services);

			// // Update selectedService if it is not in user.services
			// if (selectedService && !user.services.some((s) => s.connectionType === selectedService || isSocialNetwork(s.connectionType))) {
			// 	const serviceToBeSet = R.sortWith([R.ascend(R.prop("title"))])(
			// 		Object.entries(
			// 			[...commonOptions, ...personnalOptions, ...otherOption].filter((sr) =>
			// 				user.services.some((r) => (isSocialNetwork(r.connectionType) ? ConnectionTypes.socialNetworks === sr.connectionType : isInsurance(r.connectionType) ? ConnectionTypes.insurance === sr.connectionType : r.connectionType === sr.connectionType))
			// 			)
			// 		).map((entry) => entry[1])
			// 	)[0];

			// 	setSelectedService(isSocialNetwork(serviceToBeSet.connectionType) ? ConnectionTypes.socialNetworks : isInsurance(serviceToBeSet.connectionType) ? ConnectionTypes.insurance : serviceToBeSet.connectionType);
			// }
		}
	}, [user.services, selectedService, commonOptions, personnalOptions, otherOption]);

	// Fetch service data when selectedService changes
	useEffect(() => {
		if (selectedService) {
			dispatch(fetchServiceDataForServiceType(selectedService, "relocation"));
		}
	}, [selectedService, dispatch]);

	// Scroll to selectedService when it changes
	useEffect(() => {
		if (selectedServiceRef.current) {
			selectedServiceRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
		}
	}, [selectedService]);

	const handleScrollToTop = () => {
		if (topRef.current) {
			topRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
		}
	};

	const handleScrollToBottom = () => {
		if (bottomRef.current) {
			bottomRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
		}
	};

	return (
		<nav className="block flex-row flex-lg-column align-items-center no-scroll">
			<h2 className="sr-only visually-hidden">Services Navigation</h2>
			<header className="block w-lg-100 sticky-auto t-auto-0 z-2 mr-3 mx-lg-auto text-center bg-light pb-1">
				<button type="button" className="btn btn-icon mx-auto bnt-auto-block o-60 o-100--hover p-0 no-outline" onClick={handleScrollToTop}>
					<i className="eva eva-arrow-upward-outline fs-4"></i>
				</button>
			</header>

			<ul className={`list-unstyled sticky-auto z-0 grid grid-auto-column w-100 ${isFirefox ? "pb-5" : ""}`}>
				{R.sortWith([R.ascend(R.prop("title"))])(Object.entries(commonOptions.filter((sr) => selectedServices.some((r) => r.connectionType === sr.connectionType))).map((entry) => entry[1])).map((s, index) => {
					const isLastCommonOption = index === commonOptions.length - 1;
					const ref = index === 0 ? topRef : isLastCommonOption ? bottomRef : s.connectionType === selectedService ? selectedServiceRef : null;

					return (
						<li key={index} ref={ref} role="button" className={`card rounded border border-dim ${selectedService === s.connectionType ? "shadow" : ""}`} onClick={() => setSelectedService(s.connectionType)}>
							<CheckboxCard isSelected={selectedService === s.connectionType} selectedServices={selectedServices} setSelectedServices={setSelectedServices} service={s} />
						</li>
					);
				})}

				{R.sortWith([R.ascend(R.prop("title"))])(
					Object.entries(personnalOptions.filter((sr) => selectedServices.some((r) => (isSocialNetwork(r.connectionType) ? ConnectionTypes.socialNetworks === sr.connectionType : isInsurance(r.connectionType) ? ConnectionTypes.insurance === sr.connectionType : r.connectionType === sr.connectionType)))).map(
						(entry) => entry[1]
					)
				).map((s, index) => {
					const idx = index + commonOptions.length;
					const ref = s.connectionType === selectedService ? selectedServiceRef : null;

					return (
						<li key={idx} ref={ref} role="button" className={`card rounded border border-dim ${selectedService === s.connectionType ? "shadow" : ""}`} onClick={() => setSelectedService(s.connectionType)}>
							<CheckboxCard isSelected={selectedService === s.connectionType} selectedServices={selectedServices} setSelectedServices={setSelectedServices} service={s} isSocialNetwork={isSocialNetwork} />
						</li>
					);
				})}

				{Object.entries(otherOption.filter((sr) => selectedServices.some((r) => r.connectionType === sr.connectionType)))
					.map((entry) => entry[1])
					.map((s, index) => {
						const idx = index + commonOptions.length + personnalOptions.length;
						const ref = s.connectionType === selectedService ? selectedServiceRef : bottomRef;

						return (
							<li key={idx} ref={ref} role="button" className={`card rounded border border-dim ${selectedService === s.connectionType ? "shadow" : ""}`} onClick={() => setSelectedService(s.connectionType)}>
								<CheckboxCard isSelected={selectedService === s.connectionType} selectedServices={selectedServices} setSelectedServices={setSelectedServices} service={s} isSocialNetwork={isSocialNetwork} />
							</li>
						);
					})}
			</ul>

			<footer className="block w-lg-100 sticky-auto b-auto-0 z-2 ml-3 mx-lg-auto text-center bg-light pt-1">
				<button type="button" className="btn btn-icon mx-auto bnt-auto-block o-60 o-100--hover p-0 no-outline" onClick={handleScrollToBottom}>
					<i className="eva eva-arrow-downward-outline fs-4"></i>
				</button>
			</footer>
		</nav>
	);
};
